<!-- 实体导入对话框 -->
<template>
    <gljy-button type="info" plain icon="Upload" @click="handleImport">导入</gljy-button>
    <gljy-dialog :title="title" v-model="upload.open" width="400px" append-to-body>
        <el-upload ref="uploadRef" :limit="1" accept=".xlsx, .xls" :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport" :disabled="upload.isUploading"
            :on-progress="handleFileUploadProgress" :on-success="handleFileSuccess" :auto-upload="false" drag>
            <el-icon class="el-icon--upload">
                <upload-filled />
            </el-icon>
            <div class="el-upload__text">{{ i18nConfig("将文件拖到此处，或") }}<em>{{ i18nConfig("点击上传") }}</em></div>
            <template #tip>
                <div class="el-upload__tip text-center">
                    <div class="el-upload__tip"  v-if="isShowUpdateSupport">
                        <gljy-checkbox v-model="upload.updateSupport" >是否更新已经存在的数据</gljy-checkbox>
                    </div>
                    <span>{{ i18nConfig("仅允许导入xls、xlsx格式文件") }}</span>
                    <el-link v-if="templateUrl" type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
                        @click="importTemplate">{{ i18nConfig("下载模板") }}
                    </el-link>
                </div>
            </template>
            <slot name="tip"></slot>
        </el-upload>
        <template #footer>
            <div class="dialog-footer">
                <gljy-button type="primary" @click="submitFileForm">确定</gljy-button>
                <gljy-button @click="upload.open = false">取消</gljy-button>
            </div>
        </template>
    </gljy-dialog>
</template>
<script>
export default {
    name: "gljy-data-import"
}
</script>
<script setup name="gljyDataImport">
import { i18nConfig } from '@/utils/ruoyi'
import { getToken } from "@/utils/auth";
const { proxy } = getCurrentInstance();
const props = defineProps({
    title: String, // 标题
    importUrl: String, // 导入地址
    isShowUpdateSupport: Boolean, // 是否显示 (是否更新已经存在的数据),
    templateUrl: String
})

const emits = defineEmits(["importOk"])

/*** 用户导入参数 */
const upload = reactive({
    rootPath: import.meta.env.VITE_APP_ROOT_PATH,
    // 是否显示弹出层 
    open: false,
    // 是否禁用上传
    isUploading: false,
    // 是否更新已经存在的用户数据
    updateSupport: 0,
    // 设置上传的请求头部
    headers: { Authorization: "Bearer " + getToken() },
    // 上传的地址
    url: import.meta.env.VITE_APP_BASE_API + props.importUrl
});

/** 导入按钮操作 */
function handleImport() {
    upload.open = true;
};

/** 提交上传文件 */
function submitFileForm() {
    proxy.$refs["uploadRef"].submit();
};

/**文件上传中处理 */
const handleFileUploadProgress = (event, file, fileList) => {
    upload.isUploading = true;
};

/** 文件上传成功处理 */
const handleFileSuccess = (response, file, fileList) => {
    upload.open = false;
    upload.isUploading = false;
    proxy.$refs["uploadRef"].handleRemove(file);
    proxy.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.msg + "</div>", "导入结果", { dangerouslyUseHTMLString: true });
    emits("importOk")
};

// 下载模板
function importTemplate() {
    window.open(`${upload.rootPath}${props.templateUrl}`)
}

defineExpose({
})
</script>